import { render } from "./ProfileAccountSubpage.vue?vue&type=template&id=8179fd7a&scoped=true"
import script from "./ProfileAccountSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileAccountSubpage.vue?vue&type=script&lang=js"

import "./ProfileAccountSubpage.vue?vue&type=style&index=0&id=8179fd7a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8179fd7a"]])

export default __exports__